/* import the font-awesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

import { fas } from "@fortawesome/free-solid-svg-icons"; // import all solid icons
/* import {
    faCircleNotch,
    faAngleLeft,
    faAngleRight,
    faCircleQuestion,
    faCirclePause,
    faCircleCheck,
    faCircleXmark
} from "@fortawesome/free-solid-svg-icons"; // import partial solid icons */
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from '@fortawesome/free-brands-svg-icons'

/* const faIcon = [
    faCircleNotch,
    faAngleLeft,
    faAngleRight,
    faCircleQuestion,
    faCirclePause,
    faCircleCheck,
    faCircleXmark,
]; */

// library.add(faIcon);
library.add(fas);
//library.add(far);
//library.add(fab);
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


const fontawesomeApp = {
    install: (app) => {
        app.component('font-awesome-icon', FontAwesomeIcon);
    },
};

export default fontawesomeApp;